let deferred = null;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export const DISMISS_KEY = "amalfi-pwa-dismissed";

export function initPwa() {
  if ("serviceWorker" in navigator && window.location.protocol === "https:") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").then((reg) => reg.update()).catch(() => {});
    });
  }
  window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; emit(); });
  window.addEventListener("appinstalled", () => { deferred = null; localStorage.setItem(DISMISS_KEY, "installed"); emit(); });
}

export const canInstall = () => !!deferred;
export const onPwa = (f) => { subs.add(f); return () => subs.delete(f); };
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  const r = await deferred.userChoice;
  deferred = null;
  emit();
  return r.outcome === "accepted";
}
